import analytics from "@react-native-firebase/analytics";

export async function sendAnalyticsEvent(eventName, data) {
  await analytics().logEvent(eventName, data);
}
